import React from "react";
import { Link, useRouter } from "./../util/router";
import { Image as ImageIcon, Video as VideoIcon } from "lucide-react";

function ModeTabs() {
  const router = useRouter();
  const onVideo = router.pathname?.startsWith("/create-video");

  const baseTab =
    "group inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition";
  const activeTab =
    "bg-white text-slate-900 shadow-lg shadow-black/20";
  const inactiveTab =
    "text-white/80 hover:text-white hover:bg-white/10";

  return (
    <div className="mx-auto mb-8 flex w-full max-w-sm justify-center">
      <div
        className="flex items-center gap-1 rounded-full border border-white/10 bg-white/5 p-1 shadow-inner backdrop-blur"
        role="tablist"
        aria-label="Generation mode"
      >
        <Link
          to="/create"
          role="tab"
          aria-selected={!onVideo}
          className={`${baseTab} ${!onVideo ? activeTab : inactiveTab}`}
        >
          <ImageIcon size={16} />
          Images
        </Link>
        <Link
          to="/create-video"
          role="tab"
          aria-selected={onVideo}
          className={`${baseTab} ${onVideo ? activeTab : inactiveTab}`}
        >
          <VideoIcon size={16} />
          Video
          <span
            className={`ml-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${
              onVideo
                ? "bg-orange-500 text-white"
                : "bg-orange-500/20 text-orange-300"
            }`}
          >
            New
          </span>
        </Link>
      </div>
    </div>
  );
}

export default ModeTabs;
